import axios from 'axios';
import { API_BASE_URL } from '../config/api';

export interface BackupMetadata {
  filename: string;
  size: number;
  timestamp: string;
}

export interface RestoreResult {
  safetyBackup: string;
  restoredFrom: string;
  timestamp: string;
}

export const adminApi = {
  async downloadDatabaseBackup(): Promise<BackupMetadata> {
    const response = await axios.post(
      `${API_BASE_URL}/api/admin/backup/generate`,
      {},
      {
        responseType: 'blob',
      }
    );

    // Extract filename from Content-Disposition header
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'memberhub_backup.sql.gz';

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    // Extract size from Content-Length header
    const size = parseInt(response.headers['content-length'] || '0', 10);

    // Create blob URL and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return {
      filename,
      size,
      timestamp: new Date().toISOString(),
    };
  },

  async restoreDatabaseBackup(file: File): Promise<RestoreResult> {
    const formData = new FormData();
    formData.append('backup', file);

    const response = await axios.post(
      `${API_BASE_URL}/api/admin/backup/restore`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return {
      safetyBackup: response.data.data.safetyBackup,
      restoredFrom: response.data.data.restoredFrom,
      timestamp: response.data.data.timestamp,
    };
  },
};
